import { render, staticRenderFns } from "./MasterStores.vue?vue&type=template&id=2834f224&"
import script from "./MasterStores.vue?vue&type=script&lang=ts&"
export * from "./MasterStores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports